require('./RACancelPeriodicContributionsView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const RACover = require('../../components/commons/RACover/RACover');
const RAFooter = require('../../components/commons/RAFooter/RAFooter');
const RAResumeBox = require('../../components/commons/RAResumeBox/RAResumeBox');
const RAOneLineSymbolAmount = require('../../components/commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');

// @components
const {
    SignaturePattern,
} = require('components/signaturePattern/signaturePattern');
const RAAccordionWizard = require('../../components/RAAccordionWizard/RAAccordionWizard');
const RAAccordionWizardStep = require('../../components/RAAccordionWizardStep/RAAccordionWizardStep');
const RALandingSuccess = require('../../components/RALandingSuccess/RALandingSuccess');

// @actions
const raCancelPeriodicContributions = require('../../actions/RACancelPeriodicContributions');
const raHireManagementPlanActions = require('../../actions/RAHireManagementPlan');
const suitabilityActions = require('../../actions/RASuitabilityTest');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    recordLink,
    recordProcess,
    PROC_RA_CANCEL_CONTRIBUTIONS,
    PROC_START,
    PROC_STEP,
} = require('utilities/tagging');
const { getFirstNChars } = require('utilities/stringHelper');

// @constants
const {
    EURO_SYMBOL,
    EURO_TEXT,
    FIRST_STEP,
    MYPROFILE_BROKER_URL,
} = require('constants/index');

const { REMOVE_SCHEDULED_TRANSFER_ID } = require('constants/operationTypes');
const {
    GO_BACK_URL,
    GOAL_TRACKING_URL,
    MYPROFILE_BROKER_ROBO_URL,
    OBJECTIVE_TRACK_URL_PARA,
    PORTFOLIO_TRACKING_URL,
    PORTFOLIO_TRACK_URL_PARA,
    PROC_RA_CANCEL_CONTRIBUTIONS_CONFIRM_CANCELATION,
    WIZARD_POSITION_SINGLE,
} = require('../../raConstants/index');

//@contact center
const {
    canFinishOperative,
} = require('../../utilities/contactCenter/RACanFinishOperativeHelper');

class RACancelPeriodicContributionsView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancelContributionClick = this.handleCancelContributionClick.bind(
            this,
        );
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const customData = {
            processDetail: 'robo cartera ' + selectedStrategy,
        };

        recordProcess(PROC_RA_CANCEL_CONTRIBUTIONS, PROC_START, customData);
    }

    componentDidUpdate(prevProps) {
        const {
            immCancelPeriodicContributions,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const prevVisibleStep = prevProps.immCancelPeriodicContributions.get(
            'visibleStep',
        );
        const nextVisibleStep = immCancelPeriodicContributions.get(
            'visibleStep',
        );

        if (prevVisibleStep !== nextVisibleStep) {
            const selectedStrategy = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'name',
            ]);
            const eventTag = 'robo cartera ' + selectedStrategy;

            recordLink(
                PROC_RA_CANCEL_CONTRIBUTIONS,
                PROC_STEP + (nextVisibleStep + 1),
                eventTag,
            );
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleCancelContributionClick() {
        this.props.setVisibleStep(FIRST_STEP);
    }

    handleFinish() {
        recordLink(
            PROC_RA_CANCEL_CONTRIBUTIONS,
            PROC_RA_CANCEL_CONTRIBUTIONS_CONFIRM_CANCELATION,
        );
        this.props.finish(
            this.props.history,
            this.props.match.params.portfolioId,
        );
    }

    getBreadcrumb() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const origin = immGlobalPosition.get('originRedirection');
        let parentTitle;
        let parentUrl;
        if (origin === PORTFOLIO_TRACK_URL_PARA) {
            parentTitle = formatText(
                'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
            );
            parentUrl = `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;
        } else if (origin === OBJECTIVE_TRACK_URL_PARA) {
            parentTitle = formatText('breadcrumb-breadcrumb_objectiveTracking');
            parentUrl = `${GOAL_TRACKING_URL}/${portfolioId}`;
        }

        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText(
                    'raCancelPeriodicContributions-raCancelPeriodicContributions_breadcrumbSecond',
                ),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            ...(origin === PORTFOLIO_TRACK_URL_PARA ||
            origin === OBJECTIVE_TRACK_URL_PARA
                ? [
                      {
                          text: parentTitle,
                          url: parentUrl,
                      },
                  ]
                : []),
            {
                text: formatText(
                    'raCancelPeriodicContributions-raCancelPeriodicContributions_headerTitle',
                ),
            },
        ];
    }

    buildWizardSection(
        immCancelPeriodicContributions,
        immAccount,
        immPortfolio,
        immPrinter,
        immSignaturePattern,
        isResumeBoxActive,
        resumeTitle,
        resumeContent,
    ) {
        const finishDisabled = !canFinishOperative(
            immSignaturePattern,
            immPrinter,
        );
        const isLoading = immCancelPeriodicContributions.get('isFetching');
        const resumeBoxClassName = classnames(
            'ra-cancel-periodic-contributions-view__resume-box',
            {
                'ra-cancel-periodic-contributions-view__resume-box--active': isResumeBoxActive,
            },
        );
        const cancelButton = isResumeBoxActive
            ? this.buildCancelButton()
            : null;
        const operationParams = {
            destinationAccount:
                immAccount.getIn(['ibanComplex', 'pais']) +
                immAccount.getIn(['ibanComplex', 'digitodecontrol']) +
                immAccount.getIn(['ibanComplex', 'codbban']),
            originAccount: immPortfolio.getIn([
                'recurringTransfers',
                'originalAccount',
                'reference',
            ]),
            ammount: immPortfolio.getIn(['recurringTransfers', 'amount']),
            currency: EURO_TEXT,
        };

        return (
            <div>
                <div className={resumeBoxClassName}>
                    <RAResumeBox title={resumeTitle} content={resumeContent} />
                    <div className="ra-cancel-periodic-contributions-view__button">
                        {cancelButton}
                    </div>
                </div>
                <div className="ra-cancel-periodic-contributions-view__wizard">
                    <RAAccordionWizard
                        immSteps={immCancelPeriodicContributions.get('steps')}
                        cancelPath={MYPROFILE_BROKER_ROBO_URL}
                        finish={this.handleFinish} // eslint-disable-line
                        setVisibleStep={this.props.setVisibleStep}
                        validateStep={this.props.validateStep}
                        visibleStep={immCancelPeriodicContributions.get(
                            'visibleStep',
                        )}
                    >
                        <RAAccordionWizardStep
                            active={false}
                            activateOnClickOfAccordion={false}
                            disabled={false}
                            position={WIZARD_POSITION_SINGLE}
                            title={formatText(
                                'raCancelPeriodicContributions-raCancelPeriodicContributions_step1Title',
                            )}
                            icon="icon-firma"
                            finishDisabled={finishDisabled}
                            loading={
                                isLoading ||
                                immCancelPeriodicContributions.get('inProgress')
                            }
                            value={false}
                        >
                            <SignaturePattern
                                printTitleVaule={'roboPrintTitle-cancelPlan'}
                                operationType={REMOVE_SCHEDULED_TRANSFER_ID}
                                operationParams={operationParams}
                                displayTitle={false}
                            />
                        </RAAccordionWizardStep>
                    </RAAccordionWizard>
                </div>
            </div>
        );
    }

    buildCancelButton() {
        return (
            <OKButton onClick={this.handleCancelContributionClick}>
                <FormattedText value="raCancelPeriodicContributions-raCancelPeriodicContributions_ctaCancelContribution" />
            </OKButton>
        );
    }

    render() {
        const {
            immCancelPeriodicContributions,
            immGlobalPosition,
            immPrinter,
            immSignaturePattern,
            match: { params },
        } = this.props;
        const { portfolioId } = params;
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const immAccount = immGlobalPosition.getIn([
            'roboAccount',
            portfolioId,
        ]);
        const recurringCode = immPortfolio.getIn([
            'recurringTransfers',
            'recurringCode',
        ]);
        const periodicityKey = `raCancelPeriodicContributions-raCancelPeriodicContributions_periodicity${recurringCode}`;
        const submitSuccessful = immCancelPeriodicContributions.get(
            'submitSuccessful',
        );
        const headerTitle = formatText(
            'raCancelPeriodicContributions-raCancelPeriodicContributions_headerTitle',
        );
        const resumeTitle = formatText(
            'raCancelPeriodicContributions-raCancelPeriodicContributions_resumeTitle',
        );
        const amountObject = {
            amount: immPortfolio.getIn(['recurringTransfers', 'amount']),
            currency: EURO_SYMBOL,
        };
        const breadcrumb = this.getBreadcrumb();
        let content;
        let footer;
        const destinyValue = immPortfolio.get('hasGoal')
            ? immPortfolio.getIn(['goalInformation', 'name'])
            : immPortfolio.get('name');

        const resumeContent = [
            {
                label: formatText(
                    'raCancelPeriodicContributions-raCancelPeriodicContributions_destiny',
                ),
                value: getFirstNChars(destinyValue, 20),
            },
            {
                label: formatText(
                    'raCancelPeriodicContributions-raCancelPeriodicContributions_contributionType',
                ),
                value: formatText(
                    'raCancelPeriodicContributions-raCancelPeriodicContributions_periodic',
                ),
            },
            {
                label: formatText(
                    'raCancelPeriodicContributions-raCancelPeriodicContributions_amount',
                ),
                value: <RAOneLineSymbolAmount amountObject={amountObject} />,
            },
            {
                label: formatText(
                    'raCancelPeriodicContributions-raCancelPeriodicContributions_owner',
                ),
                value: immAccount.get('owner'),
            },
            {
                label: formatText(
                    'raCancelPeriodicContributions-raCancelPeriodicContributions_periodicity',
                ),
                value: formatText(periodicityKey),
            },
        ];

        const isResumeBoxActive =
            immCancelPeriodicContributions.get('visibleStep') === -1;

        if (!submitSuccessful) {
            content = this.buildWizardSection(
                immCancelPeriodicContributions,
                immAccount,
                immPortfolio,
                immPrinter,
                immSignaturePattern,
                isResumeBoxActive,
                resumeTitle,
                resumeContent,
            );
            footer = <RAFooter cancelPath={GO_BACK_URL} />;
        } else {
            content = (
                <RALandingSuccess
                    title={resumeTitle}
                    resumeContent={resumeContent}
                    mainButton={formatText(
                        'raCancelPeriodicContributions-raCancelPeriodicContributions_ctaFooterSuccess',
                    )}
                    mainButtonURL={MYPROFILE_BROKER_ROBO_URL}
                />
            );
        }

        return (
            <div className="ra-cancel-periodic-contributions-view hire-management-plan-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={breadcrumb}
                            success={submitSuccessful}
                            successTitle={formatText(
                                'raCancelPeriodicContributions-raCancelPeriodicContributions_successTitle',
                            )}
                            title={headerTitle}
                        />
                    </div>
                </div>
                <div className="row ra-cancel-periodic-contributions-view__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-12">{content}</div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">{footer}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RACancelPeriodicContributionsView.propTypes = {
    history: PropTypes.object.isRequired,
    immCancelPeriodicContributions: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immPrinter: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    finish: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    resetSuitabilityTest: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immCancelPeriodicContributions: state.raCancelPeriodicContributions,
        immGlobalPosition: state.raGlobalPosition,
        immPrinter: state.printer,
        immSignaturePattern: state.signaturePattern,
    }),
    {
        finish: raCancelPeriodicContributions.finish,
        reset: raCancelPeriodicContributions.reset,
        resetSuitabilityTest: suitabilityActions.reset,
        setVisibleStep: raCancelPeriodicContributions.setVisibleStep,
        validateStep: raHireManagementPlanActions.validateStep,
    },
)(withRouter(RACancelPeriodicContributionsView));
